import { render } from "./Demos.vue?vue&type=template&id=23efc944"
import script from "./Demos.vue?vue&type=script&lang=js"
export * from "./Demos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/Demos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23efc944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23efc944', __exports__)) {
    api.reload('23efc944', __exports__)
  }
  
  module.hot.accept("./Demos.vue?vue&type=template&id=23efc944", () => {
    api.rerender('23efc944', render)
  })

}


export default __exports__